module.exports = "pegasus_template/assets/theme5/google-icon-1.png";